import React, { Component } from 'react';
import ReactTable from 'react-table';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import moment from 'moment';
import 'react-table/react-table.css';
import 'react-dates/lib/css/_datepicker.css';
import './Location-List.scss';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';


class LocationList extends Component {

    constructor() {
        super();

        this.getDeliveryLocations = this.getDeliveryLocations.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.buscarLocalEntrega = this.buscarLocalEntrega.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.verTodosLocais = this.verTodosLocais.bind(this);


        this.Configurations = new Configurations();

        this.state = {
            deliveryLocations: []
        }

        this.columns = [
            {
                Header: '#',
                accessor: 'idLocalEntrega',
                className: 'text-center pointer',
                width: 60
            },
            {
                Header: 'Nome do local',
                accessor: 'nome',
                className: 'text-center pointer',
                width: 160
            },
            {
                Header: 'Responsável',
                accessor: 'nomeUsuarioResponsavel',
                className: 'text-center pointer',
                width: 250,
            },
            {
                Header: 'Transportadora',
                accessor: 'nomeTransportadoraFavorita',
                className: 'text-center pointer',
                width: 150,
            },
            {
                Header: 'Cidade',
                accessor: 'cidade',
                className: 'text-center pointer',
                width: 100,
            },
            {
                Header: 'UF',
                accessor: 'uf',
                className: 'text-center pointer',
                width: 60,
            },
            {
                id: 'dtInicio',
                Header: 'Dt. Início',
                accessor: d => {
                    return moment(d.dtInicio)
                        .local()
                        .format("DD/MM/YYYY")
                },
                className: 'pointer text-center',
                width: 100,
            },
            {
                Header: '',
                accessor: 'idLocalEntrega',
                className: 'text-center pointer',
                Cell: row => {
                    return <button onClick={() => this.props.history.push(`/logistica/locais-entrega/detalhes/${row.value}/assinantes`)} className='btn btn-sm btn-outline-info'>ver assinantes</button>
                }
            },
        ]
    }

    componentWillMount() {
        this.setState({ isLoadingLocaisEntrega: true })
        const _carriers = axios.get(this.Configurations.apiBasePath + `/logistica/locais-entrega`);
        _carriers.then(response => {
            this.setState({ listaCompletaLocaisEntrega: response.data.locaisEntrega })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingLocaisEntrega: false }));
    }



    async getDeliveryLocations(o) {
        this.setState({ loading: true })

        if (!o.pageSize) {
            o.pageSize = 150;
        } else if (!(o.page + 1)) {
        } else {

        }

        const todosLocaisEntrega = this.state.listaCompletaLocaisEntrega;
        const offset = (o.pageSize * o.page)
        const _listaLocaisEntrega = todosLocaisEntrega.slice(offset, (offset + o.pageSize))
        const seTemResto = (todosLocaisEntrega.length % o.pageSize) > 0
        const totalPaginas = seTemResto ? Number.parseInt(todosLocaisEntrega.length / o.pageSize) + 1 : Number.parseInt(todosLocaisEntrega.length / o.pageSize)
        this.setState({
            deliveryLocations: _listaLocaisEntrega,
            pages: totalPaginas,
            loading: false,
            currentPage: o.page,
            pageSize: o.pageSize
        });
    }

    handleChange(e) {
        e.preventDefault();
        const _name = e.target.name, _value = e.target.value;
        this.setState({ [_name]: _value })
    }

    buscarLocalEntrega() {
        //filtro da lista completa de locais de entrega
        //comparar o valor do input com o nome do local entrega
        const listaFiltrada = this.state.listaCompletaLocaisEntrega.filter(item => item.nome.toLowerCase().indexOf(this.state.buscaLocalEntrega.toLowerCase()) >= 0)
        //exibir a lista filtrada
        this.setState({ deliveryLocations: listaFiltrada })
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response ? err.response.data.message : 'Erro inesperado.' })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    verTodosLocais() {
        this.getDeliveryLocations({ page: this.state.currentPage, pageSize: this.state.pageSize });
    }

    render() {
        return (
            <div className="row location-list logistics">
                <div className="col-12">
                    <div className="row">
                        <div className="col-5">
                            <h2 className="title-1">Locais de entrega</h2>
                        </div>
                        <div className="col-3">
                            <input name="buscaLocalEntrega" type="text" className='form-control' autoComplete='off' placeholder='Local de entrega' onChange={this.handleChange} value={this.state.buscaLocalEntrega} />
                        </div>
                        <div className='col-2'>
                            <button className='btn btn-outline-info' onClick={this.buscarLocalEntrega}>buscar</button>
                        </div>

                        <div className="col-2 text-right">
                            <button className="btn btn-outline-success" onClick={() => this.props.history.push('/logistica/locais-entrega/detalhes/novo')}>Novo local</button>
                        </div>
                    </div>
                    <div className="row">
                        <div className='col-12 text-right'>
                            <button className='btn btn-outline-primary' onClick={this.verTodosLocais}>ver todos</button>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-12">
                            <div className='row no-gutters'>
                                <div className="col-12">
                                    {this.state.isLoadingLocaisEntrega ? (
                                        <div className="row no-gutters">
                                            <div className="col-12 text-center py-5">
                                                <div className="spinner-border text-primary" role="status" />
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="card">
                                            <div className="card-body p-0">
                                                {!!this.state.listaCompletaLocaisEntrega && (
                                                    <ReactTable
                                                        data={this.state.deliveryLocations}
                                                        columns={this.columns}
                                                        onFetchData={this.state.listaCompletaLocaisEntrega ? this.getDeliveryLocations : undefined}
                                                        defaultPageSize={150}
                                                        pages={this.state.pages}
                                                        page={this.state.currentPage || 0}
                                                        pageSize={this.state.pageSize}
                                                        manual
                                                        loading={this.state.loading}
                                                        className="-striped -highlight"
                                                        headerClassName="ebs-table-header"
                                                        previousText='Anterior'
                                                        nextText='Próximo'
                                                        loadingText='Carregando...'
                                                        noDataText='Nenhum local encontrado.'
                                                        pageText='Página'
                                                        ofText='de'
                                                        rowsText='linhas'
                                                        getTdProps={(state, rowInfo, column, instance) => {
                                                            return {
                                                                onClick: (e, handleOriginal) => {
                                                                    if (rowInfo) {
                                                                        if (column.Header === "") handleOriginal();
                                                                        else this.props.history.push(`/logistica/locais-entrega/detalhes/${rowInfo.original.idLocalEntrega}`)
                                                                    }

                                                                }
                                                            }
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                />
            </div>
        )
    }
}

export default LocationList;